import React, { Suspense } from 'react';
import { Breadcrumb } from 'core/Breadcrumb';

import { WebsiteRoutes } from './website/routes';
import { PageRoutes } from './page/routes';
import { StructureRoutes } from './structure/routes';
import { ImageRoutes } from './image/routes';
import { LinkListRoutes } from './linklist/routes';
import { StructureContentRoutes } from './structureContent/routes';

export function CmsRoutes() {
  return (
    <Suspense fallback={<>...</>}>
      <Breadcrumb />
      <WebsiteRoutes />
      <PageRoutes />
      <StructureRoutes />
      <ImageRoutes />
      <LinkListRoutes />
      <StructureContentRoutes />
    </Suspense>
  );
}
